import "./locationAdminDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LocationAdminDetailsViewComponent from "./location-admin-details-view/locationAdminDetailsViewComponent";
import LocationAdminDetailsEditComponent from "./location-admin-details-edit/locationAdminDetailsEditComponent";

interface LocationAdminDetailsViewEditComponentProps {
    locationDetails: any
    onUpdateAdminDetails: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const LocationAdminDetailsViewEditComponent = (props: LocationAdminDetailsViewEditComponentProps) => {

    const {locationDetails, onUpdateAdminDetails,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [locationAdminDetails, setLocationAdminDetails] = useState<any>(undefined);
    //setting all location details

    const handleAdminDetailsUpdate = useCallback((updatedAdminDetails: any) => {
        onUpdateAdminDetails(updatedAdminDetails);
        setMode("view");
    }, [onUpdateAdminDetails]);

    const handleAdminDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (locationDetails) {
            setLocationAdminDetails(locationDetails);
        }
    }, [locationDetails]);

    useEffect(()=>{
        onModeChange(mode)
    },[mode,onModeChange])

    return (
        <div className={'location-admin-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LocationAdminDetailsViewComponent
                    locationAdminDetails={locationAdminDetails?.adminDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <LocationAdminDetailsEditComponent
                                                              locationDetails={locationDetails}
                                                              onUpdateComplete={handleAdminDetailsUpdate}
                                                              onEditCancel={handleAdminDetailsEditCancel}
                />
            }
        </div>
    );

};

export default LocationAdminDetailsViewEditComponent;
